import React, {useState} from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import { Accordion, IItem as IIccordionItem } from '~common/accordion'
import { useIsMobile } from "~helpers/hooks/useIsMobile";
import { AmplitudeCounter } from "~/amplitude-counter";

const IncreaseConversionScreen = () => {
  const isMobile = useIsMobile();
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const questions: IIccordionItem[] = [
    {
      title: 'Не довольны количеством лидов с сайта?',
      text: <span>Установите бесплатный виджет обратного звонка на сайт, чтобы увеличить число заявок.<br /><br /><a
        href="https://callback.onlinepbx.ru" target='_blank' onClick={() => AmplitudeCounter('click_landing_callback')}>Подробнее о callback-виджете</a></span>
    },
    {
      title: 'Не успеваете обрабатывать пропущенные?',
      text: 'Подключите автоперезвон по пропущенным. Когда оператор закончит текущий разговор, АТС автоматически свяжет его с пропущенным контактом.'
    },
    {
      title: 'Теряете клиентов в нерабочее время?',
      text: 'Установите переадресацию на мобильный телефон и оставайтесь на связи из любой точки в любое время.'
    }
  ]

  const iconsDictionary = [
    null,
    <img src={process.env.PUBLIC_DIR + '/images/index_page/conversion/icon_2.svg'} />,
    <img src={process.env.PUBLIC_DIR + '/images/index_page/conversion/icon_3.svg'} />
  ]
  const colorsDictionary = ['rgb(179, 238, 226)', '#ffddb6', '#dcd3eb']

  return (
    <Screen
      id='increase_conversion'
      title={!isMobile && <span>Увеличьте <StyledScreen.GreenText>конверсию</StyledScreen.GreenText></span> || null}
    >
      <Styled.Container>
        <Styled.Left>
          <Accordion
            data={questions}
            initialElemIndex={0}
            onChange={(index: number, item: IIccordionItem) => {
              setActiveItemIndex(index)
              AmplitudeCounter('click_open_question', { question: item.title })
            }}
          />
        </Styled.Left>
        <Styled.Right>
          {
            iconsDictionary.map((icon: any, index: number) => (
              <Styled.IconWrapp noPadding={activeItemIndex === 0} isShowed={index === activeItemIndex}>
                {
                  icon
                    ? (
                      <Styled.IconBg color={colorsDictionary[activeItemIndex]}>
                        <Styled.IconPlace>
                          {icon}
                        </Styled.IconPlace>
                      </Styled.IconBg>
                    )
                    : isMobile
                      ? <img src={process.env.PUBLIC_DIR + '/images/index_page/conversion/mobile_conv_icon_1.png'} alt="увеличте конверсию" />
                      : <img width='424px' height='372' src={process.env.PUBLIC_DIR + '/images/index_page/conversion/conv_icon_1.png'} alt="увеличте конверсию" />
                }
              </Styled.IconWrapp>
            ))
          }
        </Styled.Right>
      </Styled.Container>
    </Screen>
  )
}

export { IncreaseConversionScreen }
